import React from 'react';
import './TimeOffRequestForm.scss';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { YesNoBadge } from '../common/forms/FormElements';

export default class TimeOffRequestDisplay extends React.Component {
    render() {
        const {
            timeOffRequest,
            timeOffReasons,
            timesheetStatuses,
            onTimeOffRequestClick,
        } = this.props;

        if (!timeOffRequest) {
            return null;
        }

        const timeOffReason = timeOffReasons.find(
            (torn) => torn.id == timeOffRequest.timeOffReasonId
        );

        const endDate = timeOffRequest.endDate
            ? moment(timeOffRequest.startDate).format(
                  MomentDateFormat.WeekDayNameAndDate
              )
            : '';

        const timesheetStatus = timesheetStatuses.find(
            (ts) => ts.value == timeOffRequest.timesheetStatusId
        );

        return (
            <tr onClick={() => onTimeOffRequestClick(timeOffRequest.id)}>
                <td>
                    {moment(timeOffRequest.startDate).format(
                        MomentDateFormat.WeekDayNameAndDate
                    )}
                </td>
                <td>{endDate}</td>
                <td>
                    <YesNoBadge value={timeOffRequest.isHalfDay} />
                </td>
                <td>{timeOffReason.name}</td>
                <td>{timesheetStatus.label}</td>
            </tr>
        );
    }
}
